import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import { SwipeableDrawer } from "@material-ui/core";
import ReviewDrawerContent from "./ReviewDrawerContent";
import { connect } from "react-redux";
import "../AreaSelect/style.css";

class Review extends Component {
  state = {
    drawerOpen: false,
  };

  toggleDrawer = (state) => {
    this.setState({ drawerOpen: state });
  };

  render() {
    const { language, customer, settings, user, pastOrders } = this.props;

    const feedbackForCustomersOnly =
      settings?.enable_feedback_for_customers_only;
    const hasPastOrders = pastOrders && pastOrders.length > 0;
    const hasPhone = customer && customer.phone;

    if (feedbackForCustomersOnly && (!hasPastOrders || !hasPhone)) {
      return null;
    }

    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {language === "arabic" ? "رأيك يهمنا" : "Your opinion matters"}
        </p>
        <div
          className="w-100 text-center border-top py-3 mb-1 bordered"
          style={{
            height: 60,
            backgroundColor: "white",
            textAlign: "center",
          }}
        >
          <SwipeableDrawer
            anchor="bottom"
            open={this.state.drawerOpen}
            onClose={() => this.toggleDrawer(false)}
            PaperProps={{
              style: { minHeight: 100, height: "auto" },
              className: "text-center",
            }}
            onBackdropClick={() => this.toggleDrawer(false)}
          >
            <ReviewDrawerContent closeDrawer={() => this.toggleDrawer(false)} />
          </SwipeableDrawer>
          <Button
            color="primary"
            onClick={() => this.toggleDrawer(true)}
            endIcon={language === "english" && <ThumbUpIcon />}
            startIcon={
              language === "arabic" && (
                <ThumbUpIcon style={{ transform: "scaleX(-1)" }} />
              )
            }
          >
            <span>
              {language === "english" ? "Leave feedback" : "ملاحظات او تقييم"}
            </span>
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    customer: state.customers.customerContact,
    user: state.auth.user,
    pastOrders: state.PastOrders.pastOrders,
  };
};

export default connect(mapStateToProps)(Review);
